"use client"

import { useEffect, useState } from "react"
import Productos from "./components/Productos"
import Nosotros from "./components/Nosotros"
import Videos from "./components/Videos"
import Footer from "./components/Footer"
import Footer2 from "./components/Footer2"
import Inicio from "./components/Inicio"
import Imgs from "./components/Inicio2"
import Imgs2 from "./components/Inicio3"

import Porta from "./components/Porta"
import Modal from "./components/Modal"
import Header from "./components/Header"
import ImageModal from "./components/image-modal"
import Redes from "./components/Redes"
import Aos from "aos"
import PdfModal from "./components/pdf-modal"

function App() {
  const [imageModalState, setImageModalState] = useState(null)
  const [pdfModalState, setPdfModalState] = useState(null)

  useEffect(() => {
    Aos.init({ duration: 3000 })
  }, [])

  // Para todos los botones (productos y "VER CATÁLOGO")
  const handleOpenImageModal = (imagePath, title) => {
    console.log("🖼️ Abriendo Image Modal:", title)
    setImageModalState({
      isOpen: true,
      imagePath: imagePath,
      title: title,
    })
  }

  const handleCloseImageModal = () => {
    console.log("🖼️ Cerrando Image Modal")
    setImageModalState(null)
  }

  const handleOpenPdfModal = (pdfPath, title) => {
    console.log("📄 handleOpenPdfModal llamado con:", { pdfPath, title })
    setPdfModalState({
      isOpen: true,
      pdfPath: pdfPath,
      title: title,
    })
    console.log("📄 Estado PDF Modal actualizado")
  }

  const handleClosePdfModal = () => {
    console.log("📄 Cerrando PDF Modal")
    setPdfModalState(null)
  }

  // Debug: Mostrar el estado actual
  console.log("🔍 Estado actual PDF Modal:", pdfModalState)
  console.log("🔍 Estado actual Image Modal:", imageModalState)

  return (
    <>
      <div className="d-flex flex-column gap-4">
        <Header />
        <Inicio />
        <Productos onOpenImageModal={handleOpenImageModal} />
        <Nosotros />
        <Videos />

        <Imgs />
        <Imgs2 />
        <Porta onOpenPdfModal={handleOpenPdfModal} />
      </div>
      <Modal />
      <Footer />
      <Footer2 />

      {/* Sidebar de redes sociales */}
      <Redes />

      {/* Modal de imagen para todos los botones */}
      <ImageModal
        isOpen={imageModalState?.isOpen || false}
        imagePath={imageModalState?.imagePath}
        title={imageModalState?.title}
        onClose={handleCloseImageModal}
      />

      {/* Modal de PDF para Porta */}
      <PdfModal
        isOpen={pdfModalState?.isOpen || false}
        pdfPath={pdfModalState?.pdfPath}
        title={pdfModalState?.title}
        onClose={handleClosePdfModal}
      />
    </>
  )
}

export default App
